import {
    ProductLicence, User, UserTypes
} from '@api';

type Options = {
    licence: ProductLicence | null
    licences: Array<ProductLicence>
    userProfile: User | null
};

/**
 * A user profile is considered to have access to the product if the following
 * business rules are met. School admins are always allowed as need access for
 * managment of the platform otheriwse the user is restricted by the backend
 * flags in the profile User model isActive or isExpired.
 */
export function hasProductLicenceAccess ({
    userProfile, licence, licences
}: Options): boolean {
    // For internal users they are managing the platform and aren't restricted in the same way as a customer.
    if (userProfile?.userProfileType === UserTypes.internalUsers) {
        return true;
    }

    // When the school has never bought a license before, the license data will be empty. display no-license page for admin and teachers
    // @see https://3plearning.atlassian.net/browse/COY-10280 -> AC1
    if ((userProfile?.userProfileType === UserTypes.schoolAdmins
        || userProfile?.userProfileType === UserTypes.teachers)
        && licences.length === 0) {
        return false;
    }

    // SchoolAdmins user type can access portal irrespective of licence status.
    // @see https://bitbucket.org/mathletics/3p-portal/src/cb2b7c4a900da9ee5ca0ef946956c6e99c8cbfef/common/directive/product-selector/product-selector.js#product-selector.js-112
    if (userProfile?.userProfileType === UserTypes.schoolAdmins) {
        return true;
    }

    // Licence data needs to be present to enforce the access rules.
    if (!licence || !userProfile) {
        return false;
    }

    // At least one licence has to exist on the profile data.
    // @see https://bitbucket.org/mathletics/3p-portal/src/cb2b7c4a900da9ee5ca0ef946956c6e99c8cbfef/view/header/header.js#header.js-46
    if (licences.length === 0) {
        return false;
    }

    // These flags are provided by the backend to restrict the license.
    // @see https://bitbucket.org/mathletics/3p-portal/src/cb2b7c4a900da9ee5ca0ef946956c6e99c8cbfef/common/directive/product-selector/product-selector.js#product-selector.js-117
    if (!licence.isActive || licence.isExpired) {
        return false;
    }

    return true;
}
